import Vue from 'vue'
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate'
import {
  alpha_num as alphaNum,
  email,
  regex,
  required
} from 'vee-validate/dist/rules'

extend('alpha_num', alphaNum)
extend('email', email)
extend('regex', regex)
extend('required', required)

// Custom rules
extend('min_value', (value, minValue) => {
  return parseFloat(formatString(value)) >= parseFloat(minValue[0])
})
extend('max_value', (value, maxValue) => {
  return parseFloat(formatString(value)) < parseFloat(maxValue[0])
})
const formatString = (value, fixedLocale) => {
  if (value || value === 0) {
    return value.toLocaleString(fixedLocale, {
      maximumFractionDigits: 2
    })
  }
  return ''
}
extend('not_zero', (value) => {
  let newValue
  if (value) {
    newValue = parseFloat(
      formatString(parseFloat(value.replace(/,/g, '.')), 'en')
    )
  }
  return !isNaN(newValue) && newValue !== 0
})
extend('decimals', (value) => {
  return /^[0-9.,]+$/.test(value)
})
extend('mac_address', (value) => {
  // 00:23:7e:f8:09:5d
  return /^([a-fA-F0-9]{2}([:-]|$)){6}$|([a-fA-F0-9]{4}([.]|$)){3}$/.test(value)
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

export default (ctx, inject) => {
  inject('macAddressHelper', (value, oldValue) => {
    let localValue = value
    const localOldValue = oldValue
    const lastCharacter = localOldValue?.charAt(localOldValue?.length - 1)
    const lastTwoCharacters = value?.slice(0, -2)
    if (
      (localValue > localOldValue &&
        localValue.length >= 2 &&
        lastTwoCharacters === '') ||
      (localValue > localOldValue &&
        localValue.length >= 2 &&
        lastTwoCharacters.charAt(lastTwoCharacters?.length - 1) === ':' &&
        localValue?.length < 17)
    ) {
      localValue += ':'
    } else if (lastCharacter === ':' && localValue < localOldValue) {
      localValue = localValue.slice(0, -1)
    }
    return localValue
  })
}
